import { Map } from 'immutable';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

function useLoadingOverlay(models) {
  const [modelList, _setModelList] = useState(new Map(Object.fromEntries(Array.isArray(models) ? models.map((model) => [model, false]) : [[models, false]])));

  const setLoadingModel = useCallback((model, state) => {
    _setModelList((prev) => prev.set(model, state));
  }, [_setModelList]);

  return {
    isLoading: modelList.some((state) => state),
    modelList,
    setLoadingModel,
  };
}

useLoadingOverlay.propTypes = {
  models: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

export default useLoadingOverlay;